import { createElement } from 'react';
import { I18n as I18nJs } from 'i18n-js';
import langConf from 'src/translations/langConf';
import AppLanguageStorage from 'src/translations/AppLanguageStorage';
import { toastr } from 'react-redux-toastr';
import dayjs from 'dayjs';
import { getLanguageByAppFormat, getLanguageByISO6392 } from 'src/translations/tools';
const wtsApi = require('src/api').wtsApi; // to fix circular dependency
class I18nInstance extends I18nJs {
    language = langConf.defaultLanguage;
    constructor() {
        super();
        // Show the raw translation key when a translation is missing,
        // instead of 'guess' which humanizes the key (e.g. "EmployeeName" -> "Employee name").
        this.missingTranslation.register('key', (i18n, scope) => {
            const fullScope = scope instanceof Array ? scope.join(i18n.defaultSeparator) : scope;
            return fullScope.split(i18n.defaultSeparator).slice(-1)[0];
        });
        this.missingBehavior = 'key';
        this.defaultLocale = langConf.defaultLanguage.iso6391;
    }
    async init(userLocale) {
        userLocale = AppLanguageStorage.storedPreference || userLocale;
        return this.setLocale(userLocale);
    }
    async setLocale(locale) {
        try {
            const language = getLanguageByAppFormat(locale) || langConf.defaultLanguage;
            if (!this.translations[language.iso6391]) {
                const translations = await this.loadTranslations(language.appFormat);
                this.store(translations);
            }
            this.language = language;
            this.locale = language.iso6391;
            dayjs.locale(language.iso6391);
            dayjs.updateLocale(language.iso6391, { weekStart: 1 });
            AppLanguageStorage.language = language.appFormat;
            return language.appFormat;
        }
        catch (e) {
            toastr.error('Failed to set language', '');
            return this.language.appFormat;
        }
    }
    async loadTranslations(locale) {
        const response = await wtsApi.translations.translationsList({ languages: [locale] });
        const rawTranslations = response.data.Data;
        return this.composeTranslationMap(rawTranslations);
    }
    composeTranslationMap(translations) {
        const result = {};
        translations.forEach(({ Language: Lang6392, TranslationBase, Text }) => {
            const lang = getLanguageByISO6392(Lang6392)?.iso6391;
            if (lang) {
                if (!result[lang])
                    result[lang] = {};
                result[lang][TranslationBase] = Text || null;
            }
        });
        return result;
    }
}
export const I18n = new I18nInstance();
export function Translate({ value, className, decapitalize, additionalParameters, style, tag = 'span' }) {
    let val = I18n.t(value, { ...additionalParameters });
    if (decapitalize) {
        val = val.length ? val[0].toLowerCase() + val.substring(1) : '';
    }
    if (className || style || tag) {
        return createElement(tag, { className, style }, val);
    }
    else {
        return val;
    }
}
